angular.module("leanlaw.core").factory("filterService", [function () {
  function scopeFromFilter(filter) {
    const {
      scopeAccount,
      primary,
      reviewer,
      originating
    } = filter;
    if (!scopeAccount) return 'all';
    const scopes = [];
    if (primary) scopes.push('primary');
    if (reviewer) scopes.push('reviewer');
    if (originating) scopes.push('originating');
    return scopes.length ? scopes.join(',') : 'involved';
  }
  function monthString(month) {
    return ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'][month];
  }
  function shortMonthString(month) {
    return ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][month];
  }
  const today = new Date();
  const lastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
  const dateRangeOptions = [{
    id: 'thisMonth',
    label: shortMonthString(today.getMonth())
  }, {
    id: 'lastMonth',
    label: shortMonthString(lastMonth.getMonth())
  }, {
    id: 'thisYear',
    label: 'YTD'
  }];
  const endOfPreviousMonth = new Date(today.getFullYear(), today.getMonth(), 0);
  const previousMonthString = `${monthString(endOfPreviousMonth.getMonth())} ${endOfPreviousMonth.getFullYear()}`;
  const shortPreviousMonthString = `${shortMonthString(endOfPreviousMonth.getMonth())} ${endOfPreviousMonth.getFullYear()}`;
  const startOfThisWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - today.getDay());
  const endOfWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - today.getDay() + 7);
  const startOfLastWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - today.getDay() - 7);
  function periods(short) {
    return [{
      label: "This Month",
      id: "thisMonth",
      range: {
        startDate: new Date(today.getFullYear(), today.getMonth(), 1),
        endDate: new Date(today.getFullYear(), today.getMonth() + 1, 0)
      }
    }, {
      id: 'all',
      label: "All Time",
      range: {
        startDate: null,
        //new Date(today.getFullYear() - 2, 0, 1),
        endDate: null
      }
    }, {
      label: "This Year",
      id: "thisYear",
      range: {
        startDate: new Date(today.getFullYear(), 0, 1),
        endDate: new Date(today.getFullYear(), 11, 31)
      }
    }, {
      id: 'lastYear',
      label: "Last Year",
      range: {
        startDate: new Date(today.getFullYear() - 1, 0, 1),
        endDate: new Date(today.getFullYear() - 1, 11, 31)
      }
    }, {
      label: "This Week",
      range: {
        startDate: startOfThisWeek,
        endDate: endOfWeek
      }
    }, {
      label: "Last Week",
      range: {
        startDate: startOfLastWeek,
        endDate: startOfThisWeek
      }
    }, {
      label: "Today",
      range: {
        startDate: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
        endDate: new Date(today.getFullYear(), today.getMonth(), today.getDate())
      }
    }, {
      label: `${short ? shortPreviousMonthString : previousMonthString} and earlier`,
      range: {
        startDate: null,
        //new Date(today.getFullYear() - 2, 0, 1),
        endDate: endOfPreviousMonth
      }
    }, {
      label: short ? shortPreviousMonthString : previousMonthString,
      id: "lastMonth",
      range: {
        startDate: new Date(endOfPreviousMonth.getFullYear(), endOfPreviousMonth.getMonth(), 1),
        endDate: endOfPreviousMonth
      }
    }, {
      label: "Custom Period",
      custom: true,
      range: {
        startDate: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
        endDate: new Date(today.getFullYear(), today.getMonth(), today.getDate())
      }
    }];
  }
  function formatDisabledUser(accounts) {
    return accounts.map(account => ({
      ...account,
      name: `${account.name} ${account.disabled ? "(Disabled)" : ""}`
    })).sort(sortDisabledLast);
  }
  function sortDisabledLast(a, b) {
    if (a.disabled && !b.disabled) return 1;
    if (!a.disabled && b.disabled) return -1;
    return a.name.localeCompare(b.name);
  }
  // setGlobalReportsScopeAccount / getGlobalReportsScopeAccount moved to
  // useReportFiltersStore — the two report filter directives read it directly, so the
  // state has one home instead of being a third singleton here.
  return {
    scopeFromFilter,
    monthString,
    shortMonthString,
    dateRangeOptions,
    periods,
    formatDisabledUser
  };
}]);